module.exports = __webpack_public_path__ + "static/media/empty-trainees.383fe9c4.png";